export const discordLink = 'https://discord.gg/UEPaF3j5e6';
export const githubLink = 'https://github.com/logto-io/logto';
export const githubIssuesLink = 'https://github.com/logto-io/logto/issues';
export const contactEmailLink = 'mailto:contact@logto.io';
